import BaseModel from './BaseModel'

export default class SmsBlocTextModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      LIBELLE: '',
      TEXTE: ''
    }
    super(data, relation, fields)
  }
}
